module.exports = __webpack_public_path__ + "img/laft_bg3.aade8afc.png";